export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: 'ConvoPro',
  description: 'The only Multi-Tenant CaaP platform in the world',
  navItems: [] as { label: string; href: string }[],
  loggedInNavItems: [] as { label: string; href: string }[],
  navMenuItems: [
    {
      label: 'Profile',
      href: '/profile',
    },
    {
      label: 'Dashboard',
      href: '/dashboard',
    },
    {
      label: 'Projects',
      href: '/projects',
    },
    {
      label: 'Team',
      href: '/team',
    },
    {
      label: 'Calendar',
      href: '/calendar',
    },
    {
      label: 'Settings',
      href: '/settings',
    },
    {
      label: 'Help & Feedback',
      href: '/help-feedback',
    },
    {
      label: 'Logout',
      href: '/logout',
    },
  ],
  links: {
    pricing: '/pricing',
    aiChat: '/ai-chat',
  },
};
